import _styled from "styled-components";
const _excluded = ["children", "style"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { stylePropType } from '@adsk/alloy-react-theme';

// Note: type HTMLNavElement does not exist. Suggested to use HTMLDivElement.

const BreadcrumbTrail = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      children,
      style
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("nav", _extends({
    "aria-label": "Breadcrumb",
    ref: ref
  }, props), /*#__PURE__*/React.createElement(_StyledOl, {
    $_css: [{
      display: 'flex',
      flexFlow: 'row nowrap',
      alignItems: 'center',
      padding: 0
    }, style]
  }, children));
});
BreadcrumbTrail.displayName = 'BreadcrumbTrail';
BreadcrumbTrail.propTypes = {
  /** Children handles rendering the breadcrumbs and delimiters */
  children: PropTypes.any,
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string
};
export default BreadcrumbTrail;
var _StyledOl = _styled("ol").withConfig({
  displayName: "BreadcrumbTrail___StyledOl",
  componentId: "sc-1u7qwvp-0"
})(["", ""], p => p.$_css);
//# sourceMappingURL=BreadcrumbTrail.js.map